import { Download } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { SearchParams } from '@prismamedia/one-components';
import { Filters } from '../FiltersDrawer/utils';

interface ExportButtonProps {
  filters: Filters;
  searchParams: SearchParams;
  onExport: () => void;
  loading?: boolean;
}

export const ExportButton: FC<ExportButtonProps> = ({
  onExport,
  loading = false,
}) => {
  return (
    <Tooltip title="Télécharger les articles au format CSV">
      <IconButton
        onClick={onExport}
        disabled={loading}
        sx={{
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 48,
          height: 48,
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
          '&:disabled': {
            color: 'rgba(255, 255, 255, 0.3)',
          },
        }}
      >
        <Download />
        <Typography
          sx={{ lineHeight: '12px', fontSize: 10, whiteSpace: 'nowrap' }}
        >
          Télécharger
        </Typography>
      </IconButton>
    </Tooltip>
  );
};
